<template>
  <div class="ba-card ba-w-100 ba-flex ba-gp-2 ba-f-column">
    <div class="ba-top">
      <div class="ba-title ba-gp-08 ba-ai-center">
        <span class="ba-montserrat-700 ba-color-dark5 ba-affiliation" v-text="t.label_affiliation"></span>
        <hr class='ba-hr-column'>
        <span class="ba6-affiliation-status ba-color-black1 ba-flex ba-ai-center ba-gp-06" >
          {{ t.association_status }}:
          <span v-if="!hasSalesIn90Days" :class="['ba-circle', 'ba-yellow']" ba-tooltip-position='bottom' :ba-tooltip-title="t.label_hey_builder + ' ' + t.notice_inactive_affiliate"></span>
          <span v-else-if="hasSalesIn90Days && affiliation.is_affiliate == '1'" :class="['ba-circle', 'ba-green']" ba-tooltip-position='bottom' :ba-tooltip-title="t.notice_active_associate_status"></span>
        </span>
        <hr v-if="affiliation.sponsor_name" class='ba-hr-column'>
        <button v-if="affiliation.sponsor_name" class="ba6-sponsored-button ba-flex ba-ai-center ba-gp-04" @click="toggleModal('ba6-modal-send-message-to-sponsor')">
          <span class="ba6-sponsored-text" v-text="t.you_have_been_sponsored_by+':'"></span>
          <span class="ba6-sponsored-text" v-text="affiliation.sponsor_name"></span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 0C4.48615 0 0 4.48615 0 10C0 11.6377 0.431354 13.1684 1.13086 14.5332L0.046875 18.4141C-0.205601 19.3158 0.685963 20.2073 1.58789 19.9551L5.47168 18.8711C6.83537 19.5691 8.36388 20 10 20C15.5139 20 20 15.5139 20 10C20 4.48615 15.5139 0 10 0ZM10 4.50098C11.3785 4.50098 12.5 5.62248 12.5 7.00098C12.5 8.37948 11.3785 9.50098 10 9.50098C8.6215 9.50098 7.5 8.37948 7.5 7.00098C7.5 5.62248 8.6215 4.50098 10 4.50098ZM6.75 11.501H13.25C13.939 11.501 14.5 12.0615 14.5 12.751V13.251C14.5 13.474 14.4743 13.6933 14.4238 13.9023C14.3913 14.0378 14.3217 14.1618 14.2227 14.2598C13.0877 15.3828 11.588 16.001 10 16.001C8.412 16.001 6.91284 15.3828 5.77734 14.2598C5.67834 14.1618 5.6077 14.0378 5.5752 13.9023C5.5252 13.6933 5.5 13.474 5.5 13.251V12.751C5.5 12.0615 6.061 11.501 6.75 11.501Z" fill="#4D5D71" fill-opacity="0.8"/>
          </svg>
        </button>
        <ba6-modal modal-id="ba6-modal-send-message-to-sponsor">
          <div class='ba-card ba-jc-sb ba-w-100 ba-no-shadow'>
            <div class='ba-top'>
              <span class='ba-title' v-text="t.send_message_to_sponsor"></span>
              <div class='ba-box-items ba-flex ba-gp-1'>
                <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-modal-send-message-to-sponsor')">
                  <builderall-icon code='64f7' />
                </button>
              </div>
            </div>
            <div class="ba-content-main ba-w-100 ba-grid">
              <label for="message-to-sponsor" class="ba6-label-message-to-sponsor" v-text="t.type_your_message_bellow"></label>
              <textarea 
                class="ba-textarea" 
                name="message-to-sponsor" 
                id="message-to-sponsor" 
                cols="30" 
                rows="10" 
                v-model="messageToSponsor" 
                :placeholder="t.enter_message+'...'"
              ></textarea>
            </div>
            <div class="ba-content-footer ba-w-100 ba-flex ba-jc-fe">
              <button :class="['ba-btn', 'ba-md', 'ba-blue', loadingSendMessageToSponsor || !messageToSponsor ? 'ba-disabled' : '']" :disabled="loadingSendMessageToSponsor || !messageToSponsor" @click="sendMessageToSponsor()">
                {{ t.send }}
              </button>
            </div>
          </div>
        </ba6-modal>
      </div>
    </div>
    <div class="ba-container ba-grid ba-gp-04">
      <div 
        class="ba6-switch-element ba-flex ba-gp-06"
        ba-tooltip-position='left' 
        :ba-tooltip-title='t.tooltip_profile_toogle_sponsored'
      >
        <label class='ba-switch ba-sm'>
          <input type='checkbox' class='ba-checkbox' id="sponsored-box-switch" :checked="sponsoredBoxStatus" @click="updateStatus('sponsored-box-switch')">
          <span class='ba-slider'></span>
        </label>          
        <label for="sponsored-box-switch" class="ba-ba-monstserrat-700 ba-color-dark5 ba6-switch-span">{{ t.label_receive_message_by_sponsored }}</label>      
      </div>
      <div 
        class="ba6-switch-element ba-flex ba-gp-06"
        ba-tooltip-position='left' 
        :ba-tooltip-title='t.obc_release_access_cheetah'
      >
        <label class='ba-switch ba-sm'>
          <input type='checkbox' class='ba-checkbox' id="cheetah-va-switch" :checked="cheetahVaStatus" @click="updateStatus('cheetah-va-switch')">
          <span class='ba-slider'></span>
        </label>
        <label for="cheetah-va-switch" class="ba-ba-monstserrat-700 ba-color-dark5 ba6-switch-span">{{ t.release_access_cheetah }}</label>
      </div>
      <div 
        class="ba6-switch-element ba-flex ba-gp-06"
        ba-tooltip-position='left' 
        :ba-tooltip-title='t.office_receive_email_description'
      >
        <label class='ba-switch ba-sm'>
          <input type='checkbox' class='ba-checkbox' id="receive-email-switch" :checked="receiveEmailStatus" @click="updateStatus('receive-email-switch')">
          <span class='ba-slider'></span>
        </label>   
        <label for="receive-email-switch" class="ba-ba-monstserrat-700 ba-color-dark5 ba6-switch-span">{{ t.office_receive_email }}</label>                          
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ba6-affiliation",
  props: ['routes','affiliation','t', 'hasSalesIn90Days'],
  data() {
    return {
      sponsoredBoxStatus: this.affiliation.sponsored_box_status,
      cheetahVaStatus: this.affiliation.cheetah_va_status,
      receiveEmailStatus: this.affiliation.receive_email_status,
      loadingSendMessageToSponsor: false,
      messageToSponsor: ''
    }
  },
  methods: {
    toggleModal(data){
      $(`#${data}`).toggle('show');
    },
    updateStatus(data) {
      let route = '';
      const formData = new FormData();
      let errorMessage = '';

      if(data == 'sponsored-box-switch')
      {
        this.sponsoredBoxStatus = !this.sponsoredBoxStatus;
        route = this.routes.rota_office_show_message_sponsored;
        formData.append('receiveMessageSponsored', this.sponsoredBoxStatus ? 1 : 0);
        errorMessage = 'Error to update sponsored box';
      }
      else if(data == 'cheetah-va-switch')
      {
        this.cheetahVaStatus = !this.cheetahVaStatus;
        route = this.routes.rota_office_handle_cheetah_va;
        formData.append('cheetah_va', this.cheetahVaStatus ? 1 : 0);
        errorMessage = 'Error to update cheetah va';
      }
      else
      {
        this.receiveEmailStatus = !this.receiveEmailStatus;
        route = this.routes.rota_office_receive_email;
        formData.append('receive_email', this.receiveEmailStatus ? 1 : 0);
        errorMessage = 'Error to update receive email';
      }

      axios.post(route, formData)
        .then(response => {
          if(response.data.success)
          {
            alertMsg('success', response.data.msg);
          }
          else
          {
            alertMsg('error', response.data.msg);
          }
        })
        .catch(error => {
          console.error(errorMessage, error);
        });
    },
    sendMessageToSponsor(){
      this.loadingSendMessageToSponsor = true;
      const formData = new FormData();
      formData.append('key', this.affiliation.user_key_rc4);
      formData.append('fDescription', this.messageToSponsor);
      formData.append('fCategory', 'sponsoredMessage');

      axios
        .post(this.routes.route_office_send_notifications, formData)
        .then(response => {
          alertMsg('success', response.data.msg);
        })
        .catch(error => {
          console.error('Error to send message to sponsor', error)
        })
        .finally(() => {
          this.loadingSendMessageToSponsor = false;
          this.messageToSponsor = '';
          this.toggleModal('ba6-modal-send-message-to-sponsor');
        });
    }
  }
}
</script>


<style scoped lang="scss">
.ba-hr-column{
  min-height: 26px;
}
.ba6-affiliation-status{
  font-size: 12px;
  font-weight: 600;
}
.ba6-switch-span{
  font-size: 12px;
  font-weight: 700;
}
.ba6-sponsored-button{
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  .ba6-sponsored-text{
    color: rgba(77, 93, 113, 0.80);
    font-size: 12px;
    font-weight: 500;
  }
}
.ba6-label-message-to-sponsor{
  font-size: 14px;
}
.ba6-switch-element{
  width: max-content;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/routes/Affiliation.vue